import React, { useContext } from 'react';

export const ActiveStudioContext = React.createContext();

export const useActiveStudio = () => useContext(ActiveStudioContext);
